import React from 'react';
import { Grid } from '@material-ui/core';
import { CORP_BLUE, FONT_SIZE_UPLOAD } from 'config/config';
import { FileUpload, AddOutlined } from '@mui/icons-material';
import { DeleteForeverOutlined } from '@material-ui/icons';

const safeParse = (value) => {
  if (!value) return null;

  // Si ya es objeto, lo usamos tal cual
  if (typeof value === 'object') return value;

  // Si es string, intentamos parsear
  if (typeof value === 'string') {
    try {
      return JSON.parse(value);
    } catch {
      console.warn('JSON inválido:', value);
      return null;
    }
  }

  return null;
};


const UploadSolicitados = props => {
  const {
    classes,
    changeMultiFile,
    deleteMultiFile,
    files,
    reclamo,
    changeSingleFile,
    deleteSingleFile,
    filesOtros,
  } = props;

  return (
    <Grid container>
      {reclamo.nom_antecedente.map((itemm, index) => {
        const item = safeParse(itemm);
        if (!item) return null;
        return (
          <Grid container alignItems="center" key={index}>
            <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
            <Grid item xs={4}>
              <p style={{ fontSize: FONT_SIZE_UPLOAD }}>{item.adjunto}</p>
            </Grid>
            <Grid item xs={6}>
              {files[index] === undefined ? (
                <Grid container item>
                  <Grid item xs={1}>
                    <p>{':'}</p>
                  </Grid>
                  <Grid item xs={11}>
                    <p style={{ color: 'red', fontSize: FONT_SIZE_UPLOAD }}>{'No se ha subido el Archivo'}</p>
                  </Grid>
                </Grid>
              ) : (
                <p style={{ fontSize: FONT_SIZE_UPLOAD }}>{': ' + files[index].file.name}</p>
              )}
            </Grid>
            <Grid item xs={2} container justifyContent="center">
              <Grid item xs={3}>
                <input
                  accept=".pdf"
                  className={classes.input}
                  id={'contained-button-file' + index}
                  type="file"
                  onChange={e => changeMultiFile(e, index)}
                  hidden
                />
                {files[index] === undefined ? (
                  <label htmlFor={'contained-button-file' + index}>
                    <FileUpload style={{ color: 'green', marginTop: 5, fontSize: 40, cursor: 'pointer' }} />
                  </label>
                ) : (
                  <DeleteForeverOutlined
                    onClick={e => deleteMultiFile(index)}
                    style={{ color: 'red', marginTop: 5, fontSize: 40 }}
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        );
      })}

      <Grid container>
        <Grid container alignItems="center" key={'0A'}>
          <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE, marginTop: 10 }} />
          <Grid item xs={10}>
            <p style={{ fontSize: FONT_SIZE_UPLOAD, fontWeight: 'bold' }}>{'Otros adjuntos (Máximo 2)'}</p>
          </Grid>
          <Grid item xs={2} container justifyContent="center">
            <Grid item xs={3}>
              <input
                accept=".pdf"
                className={classes.input}
                id={'contained-button-file-input'}
                type="file"
                onChange={e => changeSingleFile(e)}
                hidden
              />
              <label htmlFor={'contained-button-file-input'}>
                <AddOutlined style={{ color: 'green', marginTop: 5, fontSize: 40, cursor: 'pointer' }} />
              </label>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
        {filesOtros.length === 0
          ? null
          : filesOtros.map((item, index) => {
            return (
              <Grid container key={index}>
                <Grid container>
                  <Grid item xs={10} container alignItems="center" style={{ fontSize: FONT_SIZE_UPLOAD }}>
                    {item.file.name}
                  </Grid>
                  <Grid item xs={2} container justifyContent="flex-end">
                    <DeleteForeverOutlined
                      onClick={e => deleteSingleFile(index)}
                      style={{
                        color: 'red',
                        marginTop: 5,
                        marginBottom: 5,
                        fontSize: 40,
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid item xs={12} style={{ height: 1, backgroundColor: CORP_BLUE }} />
                </Grid>
              </Grid>
            );
          })}

        {reclamo.doc_descripcion !== '' ? (
          <Grid container>
            <Grid item xs={12} style={{ textAlign: 'left', paddingTop: 15, fontWeight: 'bold' }}>
              <p style={{ fontSize: FONT_SIZE_UPLOAD, fontWeight: 'bold' }}>Comentario:</p>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'left', paddingTop: 5 }}>
              <p style={{ fontSize: FONT_SIZE_UPLOAD }}>{reclamo.doc_descripcion}</p>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default UploadSolicitados;
